module.exports = __webpack_public_path__ + "static/media/rj_result_city5.ac591e1b.png";